module.exports = __webpack_public_path__ + "img/2.1ac72117.png";